export type ItemVisibilitySlice = {
  showNews: boolean;
  showLegal: boolean;
  showDiligence: boolean;
};

export function getCopyFromReportSections(
  itemVisibility: ItemVisibilitySlice | null,
  isWebSearchWorkbenchEntry: boolean,
  diligenceEnabled: boolean
): { includeNews: boolean; includeLegal: boolean; includeDiligence: boolean } {
  if (itemVisibility === null) {
    return { includeNews: false, includeLegal: false, includeDiligence: false };
  }
  return {
    includeNews: itemVisibility.showNews,
    includeLegal: itemVisibility.showLegal && !isWebSearchWorkbenchEntry,
    includeDiligence:
      itemVisibility.showDiligence &&
      !isWebSearchWorkbenchEntry &&
      diligenceEnabled,
  };
}
